import { gql } from '@apollo/client'

import { restInvoiceClient } from './clients.configuration'

const commonEstimateFragment = `
  id
  issueDate
  dueDate
  referenceNumber
  title
  customer {
    displayName
  }
`

const summaryFragment = `
summary {
  foreignGrossTotal
  localGrossTotal
  exchangeRate
  localCurrency
  foreignCurrency
  localNetTotal
  localTaxTotal
}
`

const lines = `
lines {
    ... on rowLine {type,date,description,quantity,netTotal,taxTotal,grossTotal,vatPct,unit,unitPrice,totalDiscount}
  }`

export const GET_ESTIMATE_QUERY = gql`
query estimate($id: Int) {
  estimate(id: $id) {
    id
    estimateNumber
    issueDate
    dueDate
    customer {
      displayName
    }
    ${summaryFragment}
    status {
      status
    }
  }
}`

const estimateFields = `
{
  estimateNumber
  ${commonEstimateFragment}
  status {
    status
    events {
      createdAt,
      eventType,
      eventData{
      ... on estimateEmailSentEventData{recipient}
      ... on estimateAcceptedEventData{userType}
      }
    }
  }
  ${summaryFragment}
  ${lines}
}`

const ESTIMATES_QUERY_SLIM = `
estimates {
  estimateNumber
  ${commonEstimateFragment}
  status {
    status
  }
  ${summaryFragment}
}`

const estimateDraftFields = `
{
  ${commonEstimateFragment}
  ${summaryFragment}
  ${lines}
}`

const DRAFT_ESTIMATES_QUERY_SLIM = `
estimateDrafts {
  ${commonEstimateFragment}
  ${summaryFragment}
}`

const estimateExternalFields = `
{
  estimateNumber
  ${commonEstimateFragment}
  status {
    status
    events {
      createdAt,
      eventType
    }
  }
  ${summaryFragment}
  ${lines}
}`

const ESTIMATES_EXTERNAL_QUERY_SLIM = `
estimateExternals {
  estimateNumber
  ${commonEstimateFragment}
  status {
    status
  }
  ${summaryFragment}
}`

export const GET_ESTIMATES_QUERY = gql`{
  estimates:
    estimates ${estimateFields}
}`

export const GET_ALL_ESTIMATES_QUERY = gql`{
  estimates:
    ${ESTIMATES_QUERY_SLIM}
  drafts:
    ${DRAFT_ESTIMATES_QUERY_SLIM}
  estimateExternals:
    ${ESTIMATES_EXTERNAL_QUERY_SLIM}
}`

export const GET_ESTIMATE_BY_ID_QUERY = gql`
  query estimate($id: Int) {
    estimate(id: $id) ${estimateFields}
  }`

export const GET_DRAFT_INVOICE_BY_ID_QUERY = gql`
  query estimate($id: Int) {
    estimateDraft(id: $id) ${estimateDraftFields}
  }`
export const GET_ESTIMATE_EXTERNAL_BY_ID_QUERY = gql`
  query estimate($id: Int) {
    estimateExternal(id: $id) ${estimateExternalFields}
  }`

export const getEstimate = (id: number) => {
  return restInvoiceClient.query({
    query: GET_ESTIMATE_QUERY,
    variables: { id },
  })
}

export const getEstimates = () => {
  return restInvoiceClient.query({
    query: GET_ESTIMATES_QUERY,
  })
}

export const refreshEstimate = (id: number) => {
  const options = { variables: { id }, fetchPolicy: 'network-only' }
  return restInvoiceClient.query({ query: GET_ESTIMATE_BY_ID_QUERY, ...options })
}
